// Import statements
import React, { useEffect } from 'react';

// Component definition
const ContactUs = () => {

  useEffect(() => {
    const element = document.getElementById('contact-us-wrapper');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <div className='contact-us-wrapper' id='contact-us-wrapper'>
      <div className='container mt-5 mb-5'>
        <div className='row align-items-center'>
          <div className='col-md-4 img_column'>
              <div className='image_wrap'>
                  <img src='/images/contact_us_banner.png'></img>
              </div>
          </div>
          <div className='col-md-4'>
            <div className='contact_info'>
              <h2>CONTACT US</h2>
              <div className='contact_detials'>
                <p><i class="fa fa-home" aria-hidden="true"></i> Shop No 5, Kahan Park, Against Super Attitude Hair Salon, Opp. Arvind Park Society, Near BAPS
                  Swaminarayn Mandir, Anil Starch Mill Road, Bapunagar, Ahmedabad -380024.</p>
              </div>
              <div className='contact_detials'>
                <a href='#'><i class="fa fa-phone" aria-hidden="true"></i> +91 9510060682</a>
              </div>
              <div className='contact_detials'>
                <a href='#'><i class="fa fa-envelope" aria-hidden="true"></i> nickoonjvanani@gmail.com</a>
              </div>
              <div className='solical_icons'>
                <p>Follow Us:</p>
                  <a href='#'><i class="fab fa-facebook-f"></i></a>
                  <a href='#'><i class="fab fa-instagram"></i></a>
                  <a href='#'><i class="fab fa-twitter"></i></a>
                  <a href='#'><i class="fab fa-linkedin-in"></i></a>
              </div>
            </div>
          </div>
          <div className='col-md-4'>
              <div className='location_wrap'>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.5831657346657!2d72.62497377482481!3d23.03907231571323!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e8696ca53def1%3A0xdbda7276452848ee!2sNikunj%20Vanani%20%26%20Associates!5e0!3m2!1sen!2sin!4v1733227032351!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Export the component
export default ContactUs;
